// Палитра цветов вариантов. Отдельный модуль — чтобы reducer.ts и seed.ts
// могли использовать её без циклической зависимости друг на друга.

/**
 * 24 цвета: шесть приглушённых и восемнадцать ярких, разложенных по кругу
 * оттенков. В сетке выбора это ровно четыре ряда по шесть — приглушённые
 * занимают первый.
 *
 * Новым вариантам цвет раздаётся по порядку, поэтому первые шесть — спокойные:
 * доска не должна пестрить сама по себе, яркое человек выбирает руками.
 *
 * Цвет варианта — его опознавательный знак: точка в шапке, кружок в сравнении
 * и обводка всей колонки. Поэтому здесь, в отличие от токенов темы, красный и
 * жёлтый не зарезервированы под валидацию — их выбирают осознанно.
 *
 * Значения лежат в состоянии, так что удалять цвет из списка нельзя: у уже
 * созданных вариантов перестанет подсвечиваться выбранный кружок.
 */
export const VARIANT_COLORS: readonly string[] = [
  // Приглушённые — ими раздаются цвета новым вариантам
  '#5b7c99', // синий
  '#6b8f71', // зелёный
  '#8a6fa3', // фиолетовый
  '#4f8a8b', // бирюзовый
  '#8c8c86', // серый
  '#9c7a5c', // охра

  // Яркие: круг оттенков с ровным шагом
  '#ff3b30', // алый
  '#ff6b1f', // киноварь
  '#ff9500', // оранжевый
  '#ffc400', // янтарный
  '#e8dd00', // жёлтый
  '#9ede00', // лаймовый
  '#4cd52f', // травяной
  '#00cc66', // изумрудный
  '#00c7b4', // морской волны
  '#00bcd4', // бирюзовый яркий
  '#00a2f5', // небесный
  '#2b7fff', // ультрамарин
  '#4f5dff', // васильковый
  '#7a3fff', // индиго
  '#a72bff', // фиолетовый яркий
  '#d420e8', // пурпурный
  '#ff1fc0', // фуксия
  '#ff2e88', // малиновый
];
